import { Reveal, SectionTag } from "./shared";
import { useLang } from "./i18n";

const COPY = {
  en: {
    tag: "The Journey", headA: "Three steps to", headB: "certainty.",
    steps: [
      { num: "01", title: "Take the assessment", color: "#1F5BFF", copy: "A 45-minute adaptive session you can pause and resume. No prep needed — honesty is the only strategy." },
      { num: "02", title: "Meet your report", color: "#F5A524", copy: "Within 48 hours, your AI-drafted, counselor-reviewed report lands with scores, stories and a ranked career map." },
      { num: "03", title: "Act with confidence", color: "#E84393", copy: "Walk your plan with a counselor: pick subjects, shortlist colleges, and set milestones you'll actually hit." },
    ],
  },
  hi: {
    tag: "सफ़र", headA: "तीन आसान कदम,", headB: "पूरा भरोसा।",
    steps: [
      { num: "01", title: "आकलन दीजिए", color: "#1F5BFF", copy: "45 मिनट का अनुकूल सेशन, जिसे आप रोककर बाद में जारी कर सकते हैं। तैयारी ज़रूरी नहीं — ईमानदार जवाब ही सबसे अच्छी रणनीति है।" },
      { num: "02", title: "अपनी रिपोर्ट से मिलिए", color: "#F5A524", copy: "48 घंटों के भीतर AI-ड्राफ़्टेड, काउंसलर-समीक्षित रिपोर्ट मिलती है — स्कोर, आपकी कहानी और क्रमबद्ध करियर मैप के साथ।" },
      { num: "03", title: "भरोसे से आगे बढ़ें", color: "#E84393", copy: "काउंसलर के साथ प्लान पर चलें: विषय चुनें, कॉलेज शॉर्टलिस्ट करें और ऐसे लक्ष्य बनाएँ जिन्हें आप सच में पूरा करेंगे।" },
    ],
  },
};

export default function Steps() {
  const { lang } = useLang();
  const copy = COPY[lang];
  return (
    <section id="journey" className="max-w-7xl mx-auto px-5 sm:px-8 py-28 sm:py-36">
      <SectionTag color="#F5A524">{copy.tag}</SectionTag>
      <Reveal>
        <h2 className="font-display font-bold text-3xl sm:text-5xl tracking-tight max-w-2xl text-balance leading-[1.05]">
          {copy.headA} <span className="font-serifa italic font-normal text-iqamber">{copy.headB}</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {copy.steps.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.12}>
            <div data-testid={`step-${s.num}`} className="group relative rounded-3xl bg-cream border border-ink/10 p-8 h-full transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_30px_60px_-20px_rgba(10,22,51,0.2)]">
              <span className="font-serifa italic text-5xl" style={{ color: s.color }}>{s.num}</span>
              <h3 className="font-display font-bold text-xl mt-6 tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-ink/60 leading-relaxed">{s.copy}</p>
              <span className="absolute top-8 right-8 h-2.5 w-2.5 rounded-full transition-transform duration-500 group-hover:scale-[2.2]" style={{ background: s.color }} />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
